// extracted by mini-css-extract-plugin
export default {"container":"ck_g","text":"ck_cZ","title":"ck_cX","button":"ck_dQ","focus-visible":"ck_gR","focusVisible":"ck_gR"};